/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Icon } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './changebadge_styles';



/* ========== ~~~~~~~~~~ CHANGE BADGE ~~~~~~~~~~ ========== */
const ChangeBadge = injectSheet(styles)(props => {
    const arrows = {
        positive: 'up',
        negative: 'down'
    }
    return (<div className={`changebage ${props.classes.changebadge}`}>
                <Icon name={`arrow-${arrows[props.direction]}`}/>
                <span>{props.change}</span>
        </div>)
})


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ChangeBadge;
